import { useEffect, useState } from 'react';
import Divider from '@mui/material/Divider';
import { XMasonry, XBlock } from 'react-xmasonry';
import useWindowDimensions from 'hooks/util/useWindowDimensions/useWindowDimensions';
import { Card } from 'components/Cards/card/card';
import CategoryAccordion from '../../../components/Cards/card/CategoryAccordion';
import { GetCompliancePortal } from 'api/training';
import LoadingIndicator from 'components/Global/loading-indicator/loading-indicator';
import { StrikeThroughHeader } from 'components/Headers/strikethrough-header/strikethrough-header';
import '../Index/Index.scss';
import { useQuery } from '@tanstack/react-query';

export default function Compliance({ categorizeArray, RetryView }) {
  const { width } = useWindowDimensions();

  const { data, isPending, isError, refetch } = useQuery({
    queryKey: ['getCompliancePortal'],
    queryFn: () => GetCompliancePortal()(),
  });

  const categorizedData = data ? categorizeArray(JSON.parse(data)) : [];

  return (
    <>
      <StrikeThroughHeader>Compliance</StrikeThroughHeader>
      <div className="page-inner-content">
        {isPending && <LoadingIndicator />}
        {isError && <RetryView message="Failed to load Compliance Items" callback={refetch} />}
        {!isPending && !isError && (
          <XMasonry maxColumns={3} responsive targetBlockWidth={500}>
            {categorizedData.map((category, index) => (
              <XBlock key={category.name}>
                <CategoryAccordion
                  key={category.name}
                  category={category}
                  index={index}
                  baseUrl={`${process.env.REACT_APP_AGENTPORTAL_PREFIX}/CompliancePortal`}
                />
              </XBlock>
            ))}
            <XBlock width={3}>
              <div className="m-2 mt-5">
                <Card
                  title="Compliance Concerns"
                  height="auto"
                  headingHeight="3em"
                  headingFontColor="white"
                  headingBgColor="#0075bf"
                  width="100%"
                >
                  <div id="compliance-concerns">
                    <div>
                      If you wish to contact Jennifer Sheehan, our VP of Legal and Compliance, click
                      Contact Jennifer. You may also complete an anonymous inquiry by submitting a
                      Customer/Associate Concern form to the attention of Jennifer Sheehan.
                    </div>
                    <Divider orientation={width >= 768 ? 'vertical' : 'horizontal'} flexItem />
                    <div id="compliance-links">
                      <a href="mailto:Jennifer.Sheehan@baltlife.com" className="btn btn-primary">
                        Contact Jennifer
                      </a>
                      <a
                        href="/SharePointFiles/3668.pdf"
                        target="_blank"
                        className="btn btn-primary"
                      >
                        Anonymous Inquiry
                      </a>
                    </div>
                  </div>
                </Card>
              </div>
            </XBlock>
          </XMasonry>
        )}
      </div>
    </>
  );
}
